import { Method } from '../../packages/neb-api-client/src/utils/api-client-utils';
import ApiClientv2 from '../../packages/neb-api-client/src/utils/api-client-v2';

export const apiClient = new ApiClientv2({
  microservice: 'billing',
});

export async function getSubscriptionCharges(patientPackageId) {
  const { data } = await apiClient.makeRequest({
    method: Method.GET,
    path: '/api/v1/tenants/:tenantId/subscriptions/:patientPackageId/charges',
    replacements: { patientPackageId },
  });

  return data;
}
